<template>
  <div>
    <div class="title">广东元正招标采购有限公司</div>
    <div class="title-line"></div>
    <div class="title-line"></div>
    <div class="title-line" style="margin-top: 4px;"></div>
    <div class="contnet-title">
      {{ psu.prsflgdesc }}结果通知书
    </div>
    <span style="color: #0b0c0d; font-weight: bold;font-family: '宋体';">{{ psu.pcomfullname }}:</span>
    <p class="content">贵单位委托我司组织的<span style="text-decoration:underline;line-height: 22px;font-weight: bold;">{{ psu.projectname }}</span><span style="font-weight:  bold;">(项目编号: {{ psu.projectcode }})</span>的{{ psu.prsflgdesc }}工作已经圆满结束,{{ prsflgDesc }}结果如下:</p>
    <div class="zb-container">
      <div style="display:flex">
        <div class="tr">{{ +psu.prsflg === 6 ? '中选' : '成交' }}人名称</div>
        <div class="tr">{{ bjname }}</div>
        <div class="tr">联系人</div>
        <div class="tr">联系电话</div>
      </div>
      <div  style="display:flex">
        <div class="td">{{ psu.comfullname }}</div>
        <div class="td">
          <template v-if="psu.projectquotationmode === 1">
            <div>¥{{ psu.psuamt | qfwVal }}</div>
            <div style="margin-top:2px;">({{ psu.psuamt | smallToBigVal }})</div>
          </template>
          <div v-else>{{ psu.psupricerate }}</div>
        </div>
        <div class="td">{{ psu.psucontactname }}</div>
        <div class="td">{{ psu.psucontactphone }}</div>
      </div>
    </div>
    <p class="content">请贵单位按照采购程序,办理有关手续。</p>
    <div class="conetent-end">
        <img v-if="Osealurl && Osealurl.length > 0" class="img" :src="uploadAddr + Osealurl[0].appendurl" width="170" height="170"/>
        <div style="position: absolute; z-index: 998;" v-if="Osealurl && Osealurl.length > 0">
          <div class=company-name>
            {{
                Osealurl[0].comfullname || Osealurl[0].cosname
            }}
          </div>
          <div class="date">{{ psu.psuconfirmtime | ConverToDate }}</div>
        </div>
    </div>
    <div style="position: fixed; bottom: 10px; left: 0; right: 0; width: 90%;margin: 0 auto;">
      <div class="title-line"  style="margin-bottom: 4px;"></div>
      <div class="title-line"></div>
      <div class="title-line"></div>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request"
import { mapGetters } from "vuex"
import utils from "../../assets/js/utils";
export default {
  data() {
    return {
      psu: {},
      type: this.$route.query.type,
      projectid:this.$route.query.projectid,
      psuid:this.$route.query.psuid,
      btnLoading: false,
      Osealurl: [],
      bgUrl: [],
      loading: false,
    };
  },
  async created() {
    await this.getPsu();
    await this.getComListbypid();
  },
  methods: {
    async getPsu() {
      this.loading = true;
      let res = await request({
        method: "get",
        url: "/xmgl/project/getpsubyid",
        params: { psuid: this.psuid },
      });
      if (res.length) {
        this.psu = res[0];
      }
      this.loading = false;
    },
    async getComListbypid() {
      let res = await request({
        method: "get",
        url: "/xmgl/project/getComListbypid",
        params: {
          projectid: this.projectid,
          cosid: this.loginUser.cosid
        },
      });
      this.Osealurl = res.filter((e) => +e.appendtype === 4);
      if (+this.psu.prsflg === 2) {
        this.bgUrl = res.filter((e) => +e.appendtype === 9);
      } else {
        this.bgUrl = res.filter((e) => +e.appendtype === 8);
      }
    },
  },
  filters: {
    qfwVal(value) {
      return utils.comdify(value);
    },
    smallToBigVal(v) {
      return utils.smallToBig(v)
    },
    ConverToDate(data) {
      let date = new Date(data);
      var chinese = ["O", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
      var y = date.getFullYear().toString();
      var m = date.getMonth() + 1;
      m = m.toString();
      var d = date.getDate().toString();
      var result = "";
      for (let i = 0; i < String(y).length; i++) {
        let z = y[i];
        result += chinese[z];
      }
      result += "年";
      if (m.length === 2) {
        if (+m[0] === 1) {
          if (+m[1] === 0) {
            result += "十月";
          } else {
            result += "十" + chinese[m.charAt(1)] + "月";
          }
        }
      } else {
        result += chinese[m.charAt(0)] + "月";
      }

      if (d.length == 2 && +d.charAt(1) !== 0) {
        if (+d.charAt(0) === 1) {
          result += '十' + chinese[d.charAt(1)] + "日";
        } else {
          result += chinese[d.charAt(0)] + '十' + chinese[d.charAt(1)] + "日";
        }
      } else if (d.length == 2 && +d.charAt(1) == 0) {
        if (+d.charAt(0) === 1) {
          result += '十日'
        } else {
          result += chinese[d.charAt(0)] + '十' + "日";
        }
      } else {
        result += chinese[d.charAt(0)] + "日";
      }
      return result;
    },
  },
  computed: {
    prsflgDesc () {
      switch (+this.psu.prsflg) {
        case 1:
          return '竞价'
        case 3:
          return '竞价'
        case 4:
          return '竞拍'
        case 5:
          return '竞拍'
        case 6:
          return '比选'
      }
    },
    uploadAddr() {
      return this.$store.getters.uploadAddr;
    },
    bjname () {
      const prefix = +this.psu.prsflg === 6 ? '中选' : '成交';
      
      switch (+this.psu.projectquotationmode) {
        case 1:
          return prefix + '金额'
          break;
        case 2:
          return prefix + '上浮率%'
          break;
        case 3:
          return prefix + '下浮率%'
          break;
        case 4:
          return prefix + '折扣率%'
          break;
      }
    },
    ...mapGetters(["loginUser"]),
  }
}
</script>
<style lang="scss" scoped>
.title {
  color: #FF0000;
  font-weight: bold;
  font-size: 32px;
  text-align: center;
  font-family: '宋体';
  display: block;
  // margin-bottom: 22px;
}
.title-line {
  width: 100%;
  border: 1px solid #FF0000;
  // height: 2px;
}
.contnet-title {
  color: #0c0d0b;
  text-align: center;
  font-size: 24px;
  margin: 18px 0;
  font-family: '宋体';
}
.content {
  color: #000;
  text-indent: 30px;
  font-family: '宋体';
}
.zb-container {
  display: flex;
  flex-direction: column;
  .tr {
    flex: 1;
    text-align: center;
    font-family: '宋体';
    border: solid 1px;
    padding: 12px;
  }
  .td {
    flex: 1;
    text-align: center;
    font-family: '宋体';
    border: solid 1px;
    border-top: none;
    padding: 12px;
  }
}
.conetent-end{
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-family: '宋体';
  position: relative;
  height: 70px;
  margin-top: 80px;
  .img {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 991;
    width:  180px;
    height: 180px;
  }
  .company-name {
    margin-bottom:8px;
  }
  .company-name, .date {
    width: 200px;
    text-align: center;
  }
}
</style>
<style lang="scss">
@media print {
  body {
    height: auto !important;
  }
}

</style>
